<template>
  <div>
    <div
      v-if="!turns.length"
      class="empty-turns text-center"
    >
      <p>{{ $t('form.emptyTurns') }}</p>
      <v-btn
        color="secondary"
        outlined
        @click="goToTurns"
      >
        {{ $t('button.createTurn') }}
      </v-btn>
    </div>
    <div v-else>
      <validation-observer ref="formCreateVacancy">
        <v-row>
          <v-col sm="6">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              min-width="auto"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider
                  v-slot="{ errors, valid }"
                  :rules="{ required: true }"
                >
                  <v-text-field
                    v-model="dateFormatted"
                    v-bind="attrs"
                    :hide-details="valid"
                    :error-messages="errors"
                    label="Criar vaga para qual dia?"
                    persistent-hint
                    outlined
                    dense
                    readonly
                    v-on="on"
                  ></v-text-field>
                </validation-provider>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                scrollable
                @input="menu = false"
              />
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="6">
            <validation-provider
              v-slot="{ errors, valid }"
              :rules="{ required: true }"
              name="turn"
            >
              <v-select
                v-model="turn"
                :label="$t('fields.turn')"
                :no-data-text="$t('noDataText')"
                :items="turns"
                :hide-details="valid"
                :error-messages="errors"
                item-text="description"
                item-value="id"
                outlined
                dense
              >
              </v-select>
            </validation-provider>
          </v-col>
          <v-col sm="3">
            <v-text-field
              v-model="startHour"
              :label="$t('fields.turnInitialHour')"
              outlined
              dense
              readonly
            ></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-text-field
              v-model="endHour"
              :label="$t('fields.turnFinalHour')"
              outlined
              dense
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </validation-observer>
      <v-row class="mt-6">
        <v-col sm="12">
          <job-vacancy
            ref="jobVacancyComponent"
            :vacancies="vacancies"
            :place-id="placeId"
            :department-id="departmentId"
          />
        </v-col>
      </v-row>
      <v-row class="mt-8">
        <v-spacer></v-spacer>
        <v-col sm="6">
          <v-btn
            block
            color="secondary"
            outlined
            @click="close"
          >
            {{ $t('button.cancel') }}
          </v-btn>
        </v-col>
        <v-col sm="6">
          <v-btn
            block
            color="primary"
            @click="create"
          >
            {{ $t('button.save') }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<style scoped>
  .empty-turns {
    margin: 3rem auto !important;
  }

  .empty-turns p {
    font-size: 0.9rem;
  }
</style>

<script>
import moment from 'moment';
import JobVacancy from '../../components/JobVacancy.vue';

export default {
  components: {
    JobVacancy,
  },

  props: {
    placeId: {
      type: String,
      required: true,
    },

    departmentId: {
      type: String,
      required: true,
    },

    activityId: {
      type: String,
      required: true,
    },

    close: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      turns: [],
      menu: null,
      date: null,
      dateFormatted: null,
      turn: null,
      startHour: null,
      endHour: null,
      vacancies: [],
    };
  },

  watch: {
    turn() {
      const turn = this.turns.find((item) => item.id === this.turn);
      this.startHour = turn.initial_hour;
      this.endHour = turn.final_hour;
      this.$refs.jobVacancyComponent.fillDefaultPricePerHour(turn.amount_hour);
    },

    date() {
      this.dateFormatted = moment(this.date).format('DD/MM/YYYY');
    },
  },

  async mounted() {
    await this.fillTurns();
  },

  methods: {
    async fillTurns() {
      this.turns = (await this.$api.turn.getMany()).data.data.filter(
        (turn) => turn.department_id === this.departmentId,
      );
    },

    async create() {
      if (!(await this.$refs.formCreateVacancy.validate())) {
        return;
      }

      const promises = this.vacancies.map(async (vacancy) => {
        try {
          await this.$api.schedule.create({
            place_id: this.placeId,
            department_id: this.departmentId,
            activity_id: this.activityId,
            customer_id: vacancy.id,
            start_date: moment(`${this.date} ${this.startHour}`, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm'),
            end_date: moment(`${this.date} ${this.endHour}`, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm'),
          });
        } catch (error) {
          this.$store.dispatch('NOTIFICATION_ERROR', error.message);
        }
      });

      await Promise.all(promises);

      this.$emit('on-change');
      this.close();
    },

    goToTurns() {
      this.$router.push(`/turns/${this.placeId}/${this.departmentId}`);
    },

    noop() {
      return null;
    },
  },
};
</script>
